module.exports = __webpack_public_path__ + "img/icon-vegan.f8ff3823.svg";